export default "__VITE_ASSET__Dx0DLe3v__"